import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL?.trim();

const api = axios.create({
  baseURL: apiUrl,
  withCredentials: true,
});

// Set initial authorization token from localStorage
const token = localStorage.getItem("accessToken");
if (token) {
  api.defaults.headers.common.Authorization = `Bearer ${token}`;
}

// Request logging (only in development)
if (process.env.NODE_ENV === "development") {
  api.interceptors.request.use(
    (config) => {
      console.log(`${config.method.toUpperCase()} ${config.baseURL}${config.url}`, {
        data: config.data,
        params: config.params,
      });
      return config;
    },
    (error) => {
      console.error("REQ ERROR", error);
      return Promise.reject(error);
    },
  );

  // Response logging
  if (process.env.NODE_ENV === "development") {
    api.interceptors.response.use(
      (response) => {
        console.log(`Response from ${response.config.baseURL}${response.config.url}`, {
          url: response.config.url,
          status: response.status,
          data: response.data,
        });
        return response;
      },
      (error) => {
        console.error("RESP ERROR", error);
        return Promise.reject(error);
      },
    );
  }
}

export default api;
